import {
	Button,
	Checkbox,
	createTheme,
	FormControl,
	IconButton,
	/* InputLabel, */
	Link,
	MenuItem,
	Paper,
	Select,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	TextField,
	useMediaQuery,
} from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import AddIcon from "@mui/icons-material/Add"
import { useContext, useEffect, useState } from "react"
import {
	/* adminGetDocuments, */ adminPublishDocumentsV2,
	getFileUrl,
	uploadMedia,
	/* uploadMediaWithProgress, */
} from "../util/firebase"
import { AdminContext } from "../views/Admin"
import UploadFileIcon from "@mui/icons-material/UploadFile"

const mdTheme = createTheme({
	palette: {
		primary: {
			main: "#132242",
		},
		secondary: {
			main: "#DF0A0A",
		},
		white: {
			main: "white",
		},
	},
})

export const fileTypes = [
	{ type: "REGISTRATION", label: "רישיון רכב" },
	{ type: "INSURANCE", label: "עבר ביטוחי" },
	{ type: "MAINTENANCE", label: "היסטוריית טיפולים" },
	{ type: "TEST", label: "בדיקת רכב ממכון מורשה" },
	{ type: "OWNERSHIP", label: "היסטורית בעלות" },
	{ type: "OTHER", label: "מסמכים אחרים" },
	{ type: "ID", label: "ספח ת.ז" },
]

const PostDocuments = ({ documents, setDocuments, publicDocuments, setPublicDocuments }) => {
	//const postAdminContext = useContext(PostAdminContext)
	//const post = postAdminContext.post
	//const [documents, setDocuments] = useState([])
	//const [publicDocuments, setPublicDocuments] = useState([])
	const [filterArray, setFilterArray] = useState([])
	const matches = useMediaQuery(mdTheme.breakpoints.up("md"))

	const adminContext = useContext(AdminContext)
	const handleOpenSnackbar = adminContext.handleOpenSnackbar
	const post = adminContext.post

	useEffect(() => {
		setFilterArray(publicDocuments.map((doc) => doc.fileName))
	}, [publicDocuments])

	useEffect(() => {
		console.log(documents)
		console.log(publicDocuments)
	}, [documents, publicDocuments])

	/* const handleGetDocuments = async () => {
		try {
			const response = await adminGetDocuments({ postId: post.id })
			console.log(response?.data)
			setDocuments(response?.data?.attachments)
			setPublicDocuments(response?.data?.publicAttachments ?? [])
		} catch (e) {
			console.log(e)
		}
	} */

	const openDoc = async (fileName) => {
		const url = await getFileUrl(fileName)
		window.open(url)
	}

	const handlePublishDocuments = async () => {

		const _publicAttachments = []
		for (let i = 0; i < publicDocuments.length; i++) {
			let match = false
			for (let j = 0; j < documents.length; j++) {
				if (publicDocuments[i].fileName === documents[j].fileName) {
					match = true
				}
			}
			if (match) _publicAttachments.push(publicDocuments[i])
		}

		try {
			await adminPublishDocumentsV2({
				postId: post.id,
				attachments: documents,
				publicAttachments: _publicAttachments,
			})
			handleOpenSnackbar("מסמכים ציבוריים עודכנו בהצלחה!", "success")
		} catch (e) {
			handleOpenSnackbar("תקלה בעידכון מסמכים ציבוריים", "error")
		}
	}

	const handleTogglePublicDocument = async (checked, index) => {
		if (checked) {
			//filterArray.push(documents[index])
			setPublicDocuments((prevState) => [...prevState, documents[index]])
		} else {
			setPublicDocuments((prevState) => prevState.filter((doc) => doc.fileName !== documents[index].fileName))
		}
	}

	const handleFileUpload = async (e, fileName, index) => {
		console.log(index)
		if (!e.target.files) {
			return
		}
		try {
			const file = e.target.files[0]
			/* await uploadMediaWithProgress(
				"private/media" + post.id + "/documents/" + +performance.now().toString() + "." + file.name.split(".").pop(),
				file,
				post.uid,
				post.id,
				file.contentType,
				() => {},
				() => {}
			) */
			const fileName =
				"private/media/" + post.id + "/documents/" + +performance.now().toString() + "." + file.name.split(".").pop()
			await uploadMedia(fileName, file, post.uid, post.id, file.contentType)
			setDocuments((prevState) => {
				const newState = [...prevState]
				newState[index] = {
					...newState[index],
					fileName: fileName,
					contentType: file.type,
					name: file.name,
				}
				return newState
			})
			handleOpenSnackbar("מסמך הוחלף בהצלחה!", "success")
		} catch (e) {
			console.log(e.message)
			handleOpenSnackbar("תקלה בהחלפת מסמך", "error")
		}
	}

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column" /* justifyContent: "center", alignItems: "center" */,
			}}
		>
			{/* <Button
				sx={{
					m: 2,
					width: matches ? "130px" : "auto",
					backgroundColor: mdTheme.palette.secondary.main,
					"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
				}}
				variant="contained"
				onClick={handleGetDocuments}
			>
				שליפת מסמכים
			</Button> */}
			{!matches &&
				documents.length > 0 &&
				documents.map((doc, index) => (
					<Paper
						sx={{ p: 2, mb: 2, backgroundColor: filterArray.indexOf(doc.fileName) > -1 ? "pink" : "#BFDDFF" }}
						key={doc.fileName}
					>
						<Table sx={{ tableLayout: "fixed" }}>
							<TableBody>
								{[
									{ field: "type", label: "סוג" },
									{ field: "name", label: "שם" },
									{ field: "view", label: "צפיה" },
									{ field: "public", label: "ציבורי?" },
									{ field: "delete", label: "מחיקה" },
								].map((col) => (
									<TableRow key={col.field}>
										<TableCell variant="head" sx={{ fontWeight: 600, width: "50px" }}>
											{col.label}
										</TableCell>
										<TableCell sx={{ textAlign: "left" }}>
											{col.field === "type" && (
												<>
													<FormControl sx={{ maxWidth: "150px" }}>
														{/* <InputLabel size="small" id={`previousOwnersHistoryMonth${i}`}>
													חודש
												</InputLabel> */}
														<Select
															value={doc[col.field]}
															/* label="חודש" */
															size="small"
															onChange={(e) => {
																setDocuments((prevState) => {
																	const newState = [...prevState]
																	newState[index] = {
																		...newState[index],
																		type: e.target.value,
																	}
																	return newState
																})
															}}
														>
															{fileTypes.map((e) => (
																<MenuItem key={e.type} value={e.type}>
																	{e.label}
																</MenuItem>
															))}
														</Select>
													</FormControl>
												</>
											)}
											{col.field === "name" && (
												<TextField
													value={doc.name}
													onChange={(e) => {
														setDocuments((prevState) => {
															const newState = [...prevState]
															newState[index] = { ...newState[index], name: e.target.value }
															return newState
														})
													}}
													size="small"
													sx={{
														mt: 0,
														ml: 0,
														mr: 1,
														mb: 0,
														maxHeight: "36px" /* maxWidth: "40px" */,
														input: { background: "white" },
													}}
												/>
											)}
											{col.field === "view" && (
												<>
													<Link sx={{ cursor: "pointer", mr: 1 }} onClick={() => openDoc(doc.fileName)}>
														צפיה
													</Link>
													<Button
														component="label"
														variant="contained"
														startIcon={<UploadFileIcon />}
														/* sx={{ marginLeft: "1rem" }} */
														size="small"
														color="secondary"
													>
														החלפה
														<input type="file" hidden onChange={(e) => handleFileUpload(e, doc.fileName, index)} />
													</Button>
												</>
											)}
											{col.field === "public" && (
												<Checkbox
													size="small"
													checked={filterArray.indexOf(doc.fileName) > -1}
													onChange={(e) => handleTogglePublicDocument(e.target.checked, index)}
												/>
											)}
											{col.field === "delete" && (
												<IconButton
													onClick={() => {
														setDocuments((prevState) => prevState.filter((e, t) => t !== index))
														setPublicDocuments((prevState) =>
															prevState.filter((doc) => doc.fileName !== documents[index].fileName)
														)
													}}
												>
													<DeleteIcon />
												</IconButton>
											)}
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</Paper>
				))}
			{!matches && (
				<IconButton
					onClick={() => {
						setDocuments((prevState) => {
							const _prevState = [...prevState]
							_prevState.push({ fileName: "", name: "", contentType: "", type: "" })
							return _prevState
						})
					}}
				>
					<AddIcon />
				</IconButton>
			)}
			{matches && documents.length > 0 && (
				<Table>
					<TableHead>
						<TableRow>
							<TableCell variant="head" sx={{ fontWeight: 600 }}>
								סוג
							</TableCell>
							<TableCell variant="head" sx={{ fontWeight: 600 }}>
								שם
							</TableCell>
							<TableCell variant="head" sx={{ fontWeight: 600 }}>
								צפיה
							</TableCell>
							<TableCell variant="head" sx={{ fontWeight: 600 }}>
								ציבורי?
							</TableCell>
							<TableCell variant="head" sx={{ fontWeight: 600 }}>
								מחיקה
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{documents.map((doc, index) => (
							<TableRow
								key={doc.fileName}
								sx={{ backgroundColor: filterArray.indexOf(doc.fileName) > -1 ? "pink" : "#BFDDFF" }}
							>
								<TableCell>
									<Select
										value={doc.type}
										/* label="חודש" */
										size="small"
										onChange={(e) => {
											setDocuments((prevState) => {
												const newState = [...prevState]
												newState[index] = {
													...newState[index],
													type: e.target.value,
												}
												return newState
											})
										}}
									>
										{fileTypes.map((e) => (
											<MenuItem key={e.type} value={e.type}>
												{e.label}
											</MenuItem>
										))}
									</Select>
								</TableCell>
								<TableCell>
									<TextField
										/* label={"יד"} */
										value={doc.name}
										onChange={(e) => {
											setDocuments((prevState) => {
												const newState = [...prevState]
												newState[index] = { ...newState[index], name: e.target.value }
												return newState
											})
										}}
										size="small"
										sx={{
											mt: 0,
											ml: 1,
											mr: 1,
											mb: 0,
											maxHeight: "36px",
											input: { background: "white" } /* maxWidth: "40px" */,
										}}
									/>
								</TableCell>
								<TableCell>
									<Link sx={{ cursor: "pointer" }} onClick={() => openDoc(doc.fileName)}>
										צפיה
									</Link>
									<Button
										component="label"
										variant="contained"
										startIcon={<UploadFileIcon />}
										sx={{ marginLeft: "1rem" }}
										size="small"
										color="secondary"
									>
										החלפה
										<input type="file" hidden onChange={(e) => handleFileUpload(e, doc.fileName, index)} />
									</Button>
								</TableCell>
								<TableCell>
									{doc.type !== "ID" ? (
										<Checkbox
											size="small"
											checked={filterArray.indexOf(doc.fileName) > -1}
											onChange={(e) => handleTogglePublicDocument(e.target.checked, index)}
										/>
									) : (
										<>&nbsp;</>
									)}
								</TableCell>
								<TableCell>
									<IconButton
										onClick={() => {
											setDocuments((prevState) => prevState.filter((e, t) => t !== index))
											setPublicDocuments((prevState) =>
												prevState.filter((doc) => doc.fileName !== documents[index].fileName)
											)
										}}
									>
										<DeleteIcon />
									</IconButton>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			)}
			{matches && (
				<IconButton
					onClick={() => {
						setDocuments((prevState) => {
							const _prevState = [...prevState]
							_prevState.push({ fileName: "", name: "", contentType: "", type: "" })
							return _prevState
						})
					}}
				>
					<AddIcon />
				</IconButton>
			)}
			{documents.length > 0 && (
				<Button
					sx={{
						m: 2,
						width: matches ? "120px" : "auto",
						backgroundColor: mdTheme.palette.secondary.main,
						"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
					}}
					variant="contained"
					onClick={handlePublishDocuments}
				>
					שמירה
				</Button>
			)}
		</div>
	)
}

export default PostDocuments
